import { render, staticRenderFns } from "./VarietyTabs.vue?vue&type=template&id=9e29ba9e&"
import script from "./VarietyTabs.vue?vue&type=script&lang=js&"
export * from "./VarietyTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports